const ChartLoader: React.FC = () => {
  return (
    <div>
      <div className="mb-4">
        <div className="h-4 w-24 animate-pulse rounded bg-muted" />
        <div className="mt-2 h-7 w-16 animate-pulse rounded bg-muted" />
      </div>
      <div className="h-64 w-full animate-pulse rounded-md bg-muted" />
    </div>
  );
};

export default ChartLoader;
